import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IDropdown, IItinerary } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./Itinerary";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { IPackageDrop } from "../../shared/generateItineraryText";
import { AutoComplete } from "primereact/autocomplete";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
    setEditModal: (modal: IOpenForm) => void,   

}

export const Table = (props: Iprops) => {

    const [checkIn, setCheckIn] = useState('morning');
    const [packageId, setPackageId] = useState(0);
    const [packages, setPackages] = useState<IPackageDrop[]>();
    const [cities, setCities] = useState<IDropdown[]>();
    const [selectedCity, setSelectedCity] = useState<IDropdown>();
    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IItinerary[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'startTime',
        sortOrder: 1
    });

    useEffect(() => {
        if (checkIn && packageId) loadTableData();
    }, [text, lazyParams, props.reload, checkIn, packageId]);

    async function onCitySearch(text: string) {
        const response = await Fetch(`city/search`, "GET", null, `text=${text}`, null);
        if (response) {
            setCities(await response.json());
        }
    }

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadPackages = async (cityId: number) => {
        const response = await Fetch(`package/dropdown/${cityId}`, "GET", null, null, null);
        if (response) {
            setPackages(await response.json());
        }
    }

    useEffect(() => { if (selectedCity?.id) { loadPackages(selectedCity.id); } }, [selectedCity]);

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("itinerary", "GET", null, `checkIn=${checkIn}&packageId=${packageId}&lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { itineraries: IItinerary[], count: number } = await response.json();
            setTableData({ data: data.itineraries, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        if (!selectedCity || !packageId) return;
        let day = 1;
        let hour = 0;
        let minute = 0;
        if (tableData.data.length > 0) {
            const maxRow = tableData.data.reduce((max, curr) => {
                const currStart = curr.startTime ?? 0;
                const maxStart = max.startTime ?? 0;
                return currStart > maxStart ? curr : max;
            }, tableData.data[0]);
            const startTime = (maxRow.startTime ?? 0) + (maxRow.duration ?? 0);
            day = Math.floor(startTime / (24 * 60)) + 1;
            hour = Math.floor((startTime % (24 * 60)) / 60);
            minute = startTime % 60;
        }
        props.setModal({
            open: true, packageTitle: packages?.find(f => f.id === packageId)?.name ?? '',
            destination: selectedCity.name,
            packageDuration: packages?.find(f => f.id === packageId)?.duration ?? 0, cityId: selectedCity.id,
            singleData: { isActive: true, checkIn: checkIn, packageId: packageId, day: day, hour: hour, minute: minute }
        });
    };

    // const openEdit = (rowData: IItinerary) => {
    //     if (!selectedCity || !packageId) return;
    //     const startTime = rowData.startTime ?? 0;
    //     const day = Math.floor(startTime / (24 * 60)) + 1;
    //     const hour = Math.floor((startTime % (24 * 60)) / 60);
    //     const minute = startTime % 60;
    //     props.setModal({
    //         open: true, packageTitle: packages?.find(f => f.id === packageId)?.name ?? '',
    //         destination: selectedCity.name,
    //         packageDuration: packages?.find(f => f.id === packageId)?.duration ?? 0, cityId: selectedCity.id,
    //         singleData: { ...rowData, day: day, hour: hour, minute: minute }
    //     });
    // };
    const openEdit = (rowData: IItinerary) => {
    if (!selectedCity || !packageId) return;
    const startTime = rowData.startTime ?? 0;
    const day = Math.floor(startTime / (24 * 60)) + 1;
    const hour = Math.floor((startTime % (24 * 60)) / 60);
    const minute = startTime % 60;
    props.setEditModal({                         // 👈 changed from setModal
        open: true,
        packageTitle: packages?.find(f => f.id === packageId)?.name ?? '',
        destination: selectedCity.name,
        packageDuration: packages?.find(f => f.id === packageId)?.duration ?? 0,
        cityId: selectedCity.id,
        singleData: { ...rowData, day, hour, minute }
    });
};

    const Remove = async (rowData: IItinerary) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`itinerary/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Activity Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IItinerary) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.packageName}-${rowData.checkIn}-${rowData.activityName}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("Itinerary", "Add") && selectedCity?.id && packageId &&
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                }
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Itinerary</h4>
                    <span style={{ margin: '0 10px' }} >City: </span>
                    <AutoComplete field="name" value={selectedCity} suggestions={cities} completeMethod={(e) => onCitySearch(e.query)} onChange={(e) => setSelectedCity(e.value)} />
                    <span style={{ margin: '0 10px' }} >Package: </span>
                    <Dropdown value={packageId} onChange={(e) => { setPackageId(e.value) }} options={packages} optionLabel="name" optionValue="id" />
                    <span style={{ margin: '0 10px' }} >CheckIn: </span>
                    <Dropdown value={checkIn} onChange={(e) => { setCheckIn(e.value) }} options={[{ id: 'morning', name: 'Morning' }, { id: 'afternoon', name: 'Afternoon' }, { id: 'evening', name: 'Evening' }]} optionLabel="name" optionValue="id" />
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} placeholder="Search Activity..." />
                </div>
                {props.hasPermission("Itinerary", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );


    const actionBodyTemplate = (rowData: IItinerary) => {
        return (
            <div className="actions">
                {props.hasPermission("Itinerary", "Edit") && <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />}
                {props.hasPermission("Itinerary", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }}  ></Button>}
            </div>
        );
    };
    const toggleStatus = async (id: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`itinerary/toggleStatus/${id}`, "PUT", null, null, props.toast);
        if (response) {
            setTableData(prev => ({ ...prev, loading: false, data: prev.data.map(d => d.id === id ? { ...d, isActive: !d.isActive } : d) }));
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }
    const statusBody = (rowData: IItinerary) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.isActive ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.isActive ? '#4caf50' : '#f44336' }}></i>
                <span onClick={() => { if (rowData.id) toggleStatus(rowData.id) }} className="cursor-pointer">{rowData.isActive ? 'Active' : 'Disable'}</span>
            </div>
        );
    }
    const startTimeBody = (rowData: IItinerary) => {
        const startTime = rowData.startTime ?? 0;
        const day = Math.floor(startTime / (24 * 60)) + 1;
        const hour = Math.floor((startTime % (24 * 60)) / 60);
        const minute = startTime % 60;
        return (
            <span>{`Day ${day} | ${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`}</span>
        );
    }
    const durationBody = (rowData: IItinerary) => {
        const duration = rowData.duration ?? 0;
        const hour = Math.floor(duration / 60);
        const minute = duration % 60;
        return (
            hour && minute ? <span>{`${hour} Hour & ${minute} Minutes`}</span>
                : hour ? <span>{hour} Hour</span> : <span>{minute} Minutes</span>
        );
    }

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows scrollable scrollHeight="75vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
            >
                {/* <Column field="packageName" header="Package" /> */}
                {/* <Column field="checkIn" header="CheckIn" /> */}
                <Column field="activityName" header="Activity" />
                <Column field="startTime" header="Start Time" sortable body={startTimeBody} />
                <Column field="duration" header="Duration" sortable body={durationBody} />
                <Column field="isActive" header="Status" sortable body={statusBody} />
                <Column field="desc" header="Description" />
                <Column field="activityTypeName" header="ActivityType" sortable />
                <Column body={actionBodyTemplate} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}
